import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../utils/AuthContext";
import { AuthURL } from './auth_routes/AuthURL';
import LoadingSpinner from "../components/loaders/LoadingSpinner";

const ProtectedRoutes = ({ children }) => {
    const { isAuthenticated, authLoading } = useAuth();
    const location = useLocation();

    if (authLoading) return <LoadingSpinner />;

    if (!isAuthenticated) {
        return (
            <Navigate
                to={AuthURL.LOGIN}
                replace
                state={{ from: location }} // send back where user came from
            />
        );
    }

    return children;
};

export default ProtectedRoutes;
